export const MOBILE_RESPONSIVE = {
  maxWidth: 767,
};
export const TABLET_RESPONSIVE = {
  minWidth: 768,
  maxWidth: 1340,
};
